// localStorageUtils.js
export default {
    // 存储数据到 localStorage
    setItem(key, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    },

    // 从 localStorage 中获取数据
    getItem(key) {
        let value = localStorage.getItem(key);
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },

    // 从 localStorage 中移除数据
    removeItem(key) {
        localStorage.removeItem(key);
    },

    // 清除 localStorage 中的所有数据
    clear() {
        localStorage.clear();
    }
};